/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { SvgsDocumentsService } from './services/svgs-documents.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    SvgsDocumentsService,
    ApiConfiguration
  ],
})
export class BlobDocumentModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BlobDocumentModule> {
    return {
      ngModule: BlobDocumentModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BlobDocumentModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BlobDocumentModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
